import { init as i18Init, register } from 'svelte-i18n';

export const supportedLangs = ['he', 'en'] as const;
export type SupportedLang = (typeof supportedLangs)[number];

export const defaultLocale: SupportedLang = 'en';

export function isSupportedLang(lang: string): lang is SupportedLang {
	return supportedLangs.includes(lang as SupportedLang);
}

export function registerLocales() {
	for (const lang of supportedLangs) {
		register(lang, () => import(`./locales/${lang}.json`));
	}
}

export function init(initialLocale?: SupportedLang) {
	const localeToUse = initialLocale || defaultLocale;

	i18Init({
		fallbackLocale: defaultLocale,
		initialLocale: localeToUse
	});
}
